//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscCloud(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H7.79C8.79 5.78 10.3 5 12 5C14.96 5 17.38 7.32 17.49 10.29L17.52 11L18.19 11.21C19.87 11.73 21 13.26 21 15C21 17.21 19.21 19 17 19H7C4.79 19 3 17.21 3 15C3 12.79 4.79 11 7 11H9V9H7C3.69 9 1 11.69 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54Z" fill="currentColor" /></svg>;
}
export default IconMiscCloud;